// removed by extract-text-webpack-plugin
module.exports = {"about":"src-layouts-components----About-module---about---3brje","aboutMeContainer":"src-layouts-components----About-module---aboutMeContainer---1UCkz","aboutPhoto":"src-layouts-components----About-module---aboutPhoto---236R3","aboutText":"src-layouts-components----About-module---aboutText---Q42dI","techStack":"src-layouts-components----About-module---techStack---2mZg0"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/About.module.css
// module id = 306
// module chunks = 114276838955818